__turbopack_context__.v({
  "actions": "jgmCUG_actions",
  "closeIcon": "jgmCUG_closeIcon",
  "container": "jgmCUG_container",
  "content": "jgmCUG_content",
  "emptyMessage": "jgmCUG_emptyMessage",
  "heading": "jgmCUG_heading",
  "infoIcon": "jgmCUG_infoIcon",
  "isEditMode": "jgmCUG_isEditMode",
  "list": "jgmCUG_list",
  "lock": "jgmCUG_lock",
  "variant--desktop": "jgmCUG_variant--desktop",
});
